import {
  CheckoutConfirmationResponseType,
  CheckoutConfirmationSavePreferencesRequestType,
  CheckoutContributionConfirmationResponseType,
  CheckoutSaveContributionNoteRequestType,
} from 'src/models/Checkout/Confirmation';
import { ApiFunctionType, httpGet, httpPost, httpPostCancellable } from 'src/utils/http';
import { AccountOrganizerValidateInternalFundingLimitReachAttemptRequestType } from 'src/models/Account/Organizer/externalContributions';

const getPath = (path: string) => `/checkout/${path}`;

export const apiGetCheckoutPaymentConfirmationData = (id: string): Promise<CheckoutConfirmationResponseType> =>
  httpGet(getPath('loadpaymentconfirmation'), {
    id,
  });

export const apiGetCheckoutContributionConfirmationData = (
  id: string
): Promise<CheckoutContributionConfirmationResponseType> =>
  httpGet(getPath('loadcontributionconfirmation'), {
    id,
  });

export const apiSaveContributionNote = (data: CheckoutSaveContributionNoteRequestType) =>
  httpPost(getPath('savecontributionnote'), data);

export const apiSavePreferences: ApiFunctionType<
  CheckoutConfirmationSavePreferencesRequestType,
  CheckoutConfirmationSavePreferencesRequestType
> = httpPostCancellable(getPath('savePreferences'));

export const apiValidateInternalFundingLimitReachAttempt = (
  data: AccountOrganizerValidateInternalFundingLimitReachAttemptRequestType
) => httpPost(getPath('validateinternalfundinglimitreachattempt'), data);

export const apiSubmitP2pRegistrationFreeContribution: ApiFunctionType<{ ID: number }, { RedirectUrl: string }> =
  httpPostCancellable(getPath('SubmitP2pRegistrationFreeContribution'));
